import React from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { AppAntSwitch } from "@components"

export default function UserOnlyExportSwitch() {

	const { onlyExport, setOnlyExportInfo } = useAdminUsersInfo(userPayload.peek()?.userConfig?.onlyExport, "onlyExport", "userConfig")

	return <AppAntSwitch
		checked={onlyExport}
		falseText="Only Export"
		onChange={e => setOnlyExportInfo(e.target.checked)}
	/>
}